export default class NetworkError {
  status: number
  msg: string

  constructor (msg = '网络错误') {
    this.status = 0
    this.msg = msg
  }
}